import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';

import { CinemaImageListResponse, CinemaListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient, { RequestConfig } from '@/utils/api/cineamoApiClient';
import { CinemaApiEmbed } from '@cineamo/api/resources/cinema/cinema-api.embed';

import { buildUrlQuery, UrlQueryParameter } from '@/helpers/url-query-helper';
import { isLocalEnvironment } from '@cineamo/ui/src/helpers/environment-helper';

export async function getCinemaById(cinemaId: number | string): Promise<ApiResponse<CinemaDto>> {
    return await apiClient
        .get(`${API_URL}/cinemas/${cinemaId}`, {
            tags: [`/cinemas/${cinemaId}`],
            revalidate: isLocalEnvironment() ? 0 : 3600 // 1h
        })
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

export async function getCinemaByDomain(domain: string): Promise<ApiResponse<CinemaDto>> {
    return await apiClient
        .get(`${API_URL}/cinemas/domain/${domain}`, {
            tags: [`/cinemas/domain/${domain}`],
            revalidate: isLocalEnvironment() ? 0 : 3600 // 1h
        })
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

export type GetCinemasQueryParameter = {
    isPrivateBookingPartner?: boolean;
    isActive?: boolean;
    countryCode?: string;
    employedUserId?: string | number;
    favoritedUserId?: string | number;
    cinemaChainId?: string | number;
    longitude?: number;
    latitude?: number;
    distance?: number;
    embed?: CinemaApiEmbed[];
    metricStartDatetime?: string;
    metricEndDatetime?: string;
    isWebsiteCustomer?: boolean;
} & UrlQueryParameter;

export async function getCinemas(
    params?: GetCinemasQueryParameter,
    config?: RequestConfig
): Promise<ApiResponse<CinemaListResponse>> {
    return await apiClient
        .get(`${API_URL}/cinemas${buildUrlQuery(params)}`, config)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}

export async function getCinemaImages(
    cinemaId: CinemaDto['id'],
    params?: UrlQueryParameter
): Promise<ApiResponse<CinemaImageListResponse>> {
    return await apiClient
        .get(`${API_URL}/cinemas/${cinemaId}/images${buildUrlQuery(params)}`)
        .then((response) => response)
        .catch(() => {
            return null;
        });
}
